module.exports = __webpack_public_path__ + "static/img/03_03_wah.42ebc2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/03_03_wah.png
// module id = 6b3Y
// module chunks = 12